import { Component, TemplateRef, HostBinding } from '@angular/core';
import { ToastService } from 'src/app/shared/services/toast/toast.service';

@Component({
    selector: 'app-toasts',
    template: `
      <ngb-toast
        *ngFor="let toast of toastService.toasts"
        [header]="toast.headertext"
        [class]="toast.classname"
        [autohide]="toast.autohide"
        [delay]="toast.delay || 5000"
        (hidden)="toastService.remove(toast)"
      >
        <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
          <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
        </ng-template>

        <ng-template #text>{{ toast.textOrTpl }}</ng-template>
      </ngb-toast>
  `,
    standalone: false
})
export class ToastComponent {
  constructor(public toastService: ToastService) {}

  @HostBinding('class.ngb-toasts')
  get item() {
    return true;
  }

  isTemplate(toast) {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
